import { Tooltip } from "@mui/material";
import { formatNumber } from "helpers/utils";
import { useTranslation } from "react-i18next";

interface IProvisionDetailsProps {
    initialProvision: number;
    currentProvision: number;
}

const ProvisionDetails = ({ initialProvision, currentProvision }: IProvisionDetailsProps) => {
    const [t] = useTranslation();

    const getProvisionText = (provision: number, type: "N-1" | "N"): string => {
        let sign = "";
        if (type === "N" && provision !== 0) {
            provision = -provision;
        }
        if (type === "N-1" && provision > 0) {
            sign = "+";
        }
        const amount = formatNumber(provision / 100, {
            isCurrency: true,
            noDigit: true,
        });
        return `${sign}${amount}`;
    };

    const provisionN1 = getProvisionText(initialProvision, "N-1");
    const provision = getProvisionText(currentProvision, "N");

    const tooltipTitle = () => {
        return (
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <span>{t("Management.InitialProvisionWithAmount", { amount: provisionN1 })}</span>
                <span>{t("Management.CurrentProvisionWithAmount", { amount: provision })}</span>
            </div>
        );
    };

    return (
        <Tooltip title={tooltipTitle()}>
            <div className="amount-details">
                {t("Management.ProvisionDetails", { amountN1: provisionN1, amount: provision })}
            </div>
        </Tooltip>
    );
};

export default ProvisionDetails;
